(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arc-journey"] && !Shopify.designMode) return;
  try {
    
  class ArcJourney extends HTMLElement {
    /** @type {HTMLElement | null} */
    #lineFill = null;
    /** @type {NodeListOf<HTMLDetailsElement>} */
    #stages;
    /** @type {IntersectionObserver | null} */
    #observer = null;

    connectedCallback() {
      this.#lineFill = this.querySelector('.arc-journey__line-fill');
      this.#stages = this.querySelectorAll('.arc-journey__stage');

      if (!this.#lineFill || this.#stages.length === 0) return;

      this.#initObserver();
      this.#updateLineFill();

      for (const stage of this.#stages) {
        stage.addEventListener('toggle', () => this.#updateLineFill());
      }
    }

    disconnectedCallback() {
      this.#observer?.disconnect();
      this.#observer = null;
    }

    #initObserver() {
      this.#observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              entry.target.classList.add('arc-journey__stage--visible');
            }
          }
          this.#updateLineFill();
        },
        {
          root: null,
          rootMargin: '0px 0px -20% 0px',
          threshold: 0.1,
        }
      );

      for (const stage of this.#stages) {
        this.#observer.observe(stage);
      }
    }

    #updateLineFill() {
      if (!this.#lineFill) return;

      const visibleStages = this.querySelectorAll('.arc-journey__stage--visible');
      const total = this.#stages.length;

      if (total === 0 || visibleStages.length === 0) {
        this.#lineFill.style.height = '0%';
        return;
      }

      const lastVisible = visibleStages[visibleStages.length - 1];
      const lastIndex = parseInt(lastVisible.dataset.stageIndex || '0', 10);
      const percentage = ((lastIndex + 1) / total) * 100;
      this.#lineFill.style.height = `${percentage}%`;
    }
  }

  if (!customElements.get('arc-journey')) {
    customElements.define('arc-journey', ArcJourney);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bmi-visualization"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';

    var params = new URLSearchParams(window.location.search);
    var bmi = parseFloat(params.get('bmi'));
    var weight = parseFloat(params.get('weight'));
    var goal = parseFloat(params.get('goal'));
    var heightFt = parseInt(params.get('hf'));
    var heightIn = parseInt(params.get('hi'));

    if (isNaN(bmi)) bmi = 30.4;
    if (isNaN(weight)) weight = 200;
    if (isNaN(goal)) goal = 150;
    if (isNaN(heightFt)) heightFt = 5;
    if (isNaN(heightIn)) heightIn = 8;

    var weightDelta = Math.round(weight - goal);
    var heightDisplay = heightFt + "'" + heightIn + '"';
    var totalInches = (heightFt * 12) + heightIn;
    var goalBmi = Math.round((goal / (totalInches * totalInches)) * 703 * 10) / 10;
    var markerPercent = Math.min(Math.max(((bmi - 15) / (45 - 15)) * 100, 2), 98);
    var currentBarHeight = 85;
    var goalBarHeight = Math.max(Math.round((goalBmi / bmi) * currentBarHeight), 25);

    var fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href = 'https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,700&family=DM+Mono:wght@300;400;500&display=swap';
    document.head.appendChild(fontLink);

    var root = document.getElementById('ivBmiRoot');
    if (!root) return;

    var wrap = document.createElement('div');
    wrap.className = 'iv-bmi';
    wrap.innerHTML = [
      '<div class="iv-hdr">',
        '<div class="iv-eye">Clinical Qualification</div>',
        '<div class="iv-h2">You qualify for GLP-1 treatment. <span>Here\'s your starting point.</span></div>',
      '</div>',
      '<div class="iv-card">',
        '<div class="iv-lbl">Your BMI</div>',
        '<div class="iv-numrow">',
          '<div class="iv-num" id="ivBmiNum">--</div>',
          '<div class="iv-stats">',
            '<span class="iv-chip">' + weight + ' lbs</span>',
            '<span class="iv-chip">' + heightDisplay + '</span>',
          '</div>',
        '</div>',
        '<div class="iv-sc">',
          '<div class="iv-trk">',
            '<div class="iv-seg iv-s1"></div>',
            '<div class="iv-seg iv-s2"></div>',
            '<div class="iv-seg iv-s3"></div>',
            '<div class="iv-seg iv-s4"></div>',
            '<div class="iv-seg iv-s5"></div>',
            '<div class="iv-seg iv-s6"></div>',
          '</div>',
          '<div class="iv-mkr" id="ivMkr"></div>',
          '<div class="iv-sclbl"><span>18.5</span><span>25</span><span>30</span><span>35</span><span>40+</span></div>',
        '</div>',
        '<div class="iv-rx">',
          '<div class="iv-chk"><svg viewBox="0 0 12 12"><polyline points="2 6 5 9 10 3"></polyline></svg></div>',
          '<div class="iv-rxt"><strong>Your BMI qualifies you for treatment.</strong> Your clinician will use this along with your full history to build your protocol.</div>',
        '</div>',
      '</div>',
      '<div class="iv-gc">',
        '<div class="iv-lbl">Your Goal</div>',
        '<div class="iv-gbars">',
          '<div class="iv-gbg">',
            '<div class="iv-gbv">' + bmi.toFixed(1) + '</div>',
            '<div class="iv-gb iv-gbc" id="ivCBar"></div>',
            '<div class="iv-gbl">Current BMI</div>',
          '</div>',
          '<div class="iv-gbg">',
            '<div class="iv-gbv">' + goalBmi.toFixed(1) + '</div>',
            '<div class="iv-gb iv-gbt" id="ivGBar"></div>',
            '<div class="iv-gbl">Goal BMI</div>',
          '</div>',
        '</div>',
        '<div class="iv-gd">',
          '<div class="iv-gda">&#8595;</div>',
          '<div class="iv-gdt">' + weightDelta + ' lbs <span>to your goal weight</span></div>',
        '</div>',
      '</div>',
      '<div class="iv-cn">',
        '<p><strong>Your clinician reviews your full profile</strong> before prescribing, including your BMI, health history, current medications, and goals. This is not an automated approval.</p>',
      '</div>'
    ].join('');

    root.appendChild(wrap);

    var bmiEl = document.getElementById('ivBmiNum');
    var startTime = null;
    function animateBmi(ts) {
      if (!startTime) startTime = ts;
      var p = Math.min((ts - startTime) / 1000, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      bmiEl.textContent = (bmi * eased).toFixed(1);
      if (p < 1) requestAnimationFrame(animateBmi);
    }

    setTimeout(function() { requestAnimationFrame(animateBmi); }, 500);
    setTimeout(function() { document.getElementById('ivMkr').style.left = markerPercent + '%'; }, 800);
    setTimeout(function() { document.getElementById('ivCBar').style.height = currentBarHeight + '%'; }, 1200);
    setTimeout(function() { document.getElementById('ivGBar').style.height = goalBarHeight + '%'; }, 1400);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["build-your-stack"]) return;
  try {
    
/* ============================================
   BUILD YOUR STACK – Controller
   ============================================
   All editable config is in this object.
   Change tier names, prices, variant IDs here.

   DO NOT CHANGE the cart payload structure.
   The _isClassicBoxV2 / _pvgid keys are load-
   bearing for Skio Static Box V2.
   ============================================ */

const BYS_DEFAULTS = {
  defaultTier: 1,
  sellingPlanId: '7832338720',
  cartRedirect: '/cart',
  strings: {
    widgetCount: '[count] / [max] filled',
    mobileCount: '[count] / [max]',
    slot: 'Slot [n]',
    submit: 'Add to Cart',
    submitLoading: 'Adding…',
    errorPrefix: 'Something went wrong.',
    select: 'Select',
    selected: 'Selected'
  },
  tiers: [
    { id: 1, name: 'Single Protocol', items: 1, price: 189, priceLabel: '$189', variantId: '52291993993504' },
    { id: 2, name: 'Dual Protocol',   items: 2, price: 299, priceLabel: '$299', variantId: '52291994026272' },
    { id: 3, name: 'Full Stack',      items: 3, price: 429, priceLabel: '$429', variantId: '52291994059040' }
  ]
};

/* Settings arrive from Liquid via the JSON tag in the markup, because
   Liquid does not render inside the javascript tag. Falls back to the
   literals above if the tag is missing or malformed. */
let CONFIG = BYS_DEFAULTS;

function bysReadConfig(root) {
  const el = root.querySelector('script[type="application/json"][data-bys-config]');
  if (!el) return BYS_DEFAULTS;
  try {
    const p = JSON.parse(el.textContent);
    if (!Array.isArray(p.tiers) || p.tiers.length === 0) return BYS_DEFAULTS;
    return {
      ...BYS_DEFAULTS,
      ...p,
      strings: { ...BYS_DEFAULTS.strings, ...(p.strings || {}) }
    };
  } catch (e) {
    console.error('BYS: config parse failed, using defaults', e);
    return BYS_DEFAULTS;
  }
}

class BuildYourStack {
  #selectedTier = null;
  #selectedProducts = new Map();

  constructor() {
    this.tierEls = document.querySelectorAll('.bys__tier[data-tier]');
    this.cells = document.querySelectorAll('.bys__cell');
    this.navCount = document.getElementById('bys-nav-count');
    this.statusFill = document.getElementById('bys-status-fill');
    this.statusNum = document.getElementById('bys-status-num');
    this.statusMax = document.getElementById('bys-status-max');
    this.footerLabel = document.getElementById('bys-footer-label');
    this.footerTags = document.getElementById('bys-footer-tags');
    this.footerPrice = document.getElementById('bys-footer-price');
    this.submitBtn = document.getElementById('bys-submit');
    this.clearBtn = document.getElementById('bys-clear');
    this.errorEl = document.getElementById('bys-error');
    this.widgetSlots = document.getElementById('bys-widget-slots');
    this.widgetTier = document.getElementById('bys-widget-tier');
    this.widgetCount = document.getElementById('bys-widget-count');
    this.widgetPrice = document.getElementById('bys-widget-price');
    this.widgetSubmit = document.getElementById('bys-widget-submit');
    this.mbarTier = document.getElementById('bys-mbar-tier');
    this.mbarCount = document.getElementById('bys-mbar-count');
    this.mbarPrice = document.getElementById('bys-mbar-price');
    this.mbarSubmit = document.getElementById('bys-mbar-submit');
    this.mbarItems = document.getElementById('bys-mbar-items');

    this.#bindTierClicks();
    this.#bindCellClicks();
    this.#bindSubmit();
    this.#bindClear();
    this.#bindNavLinks();
    this.#initReveals();

    const _p = new URLSearchParams(window.location.search);
    const _t = parseInt(_p.get('tier'), 10);
    const _first = CONFIG.tiers[0] ? CONFIG.tiers[0].id : 1;
    const _dt = CONFIG.tiers.some(t => t.id === CONFIG.defaultTier) ? CONFIG.defaultTier : _first;
    this.#selectTier(CONFIG.tiers.some(t => t.id === _t) ? _t : _dt);

    const _ph = _p.get('product');
    if (_ph) {
      const _cell = document.querySelector(`.bys__cell[data-product-handle="${_ph}"]`);
      if (_cell) this.#addProduct(_cell.dataset.variantId, _cell.dataset.productTitle, false);
    }
  }

  #bindTierClicks() {
    for (const el of this.tierEls) {
      const handler = () => {
        this.#selectTier(parseInt(el.dataset.tier, 10));
      };
      el.addEventListener('click', handler);
      el.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handler();
        }
      });
    }
  }

  #bindCellClicks() {
    for (const cell of this.cells) {
      const handler = () => {
        const vid = cell.dataset.variantId;
        const title = cell.dataset.productTitle;
        if (this.#selectedProducts.has(vid)) {
          this.#removeProduct(vid);
        } else {
          this.#addProduct(vid, title);
        }
      };
      cell.addEventListener('click', handler);
      cell.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handler();
        }
      });
    }
  }

  #bindSubmit() {
    if (this.submitBtn) this.submitBtn.addEventListener('click', () => this.#addToCart());
    if (this.widgetSubmit) this.widgetSubmit.addEventListener('click', () => this.#addToCart());
    if (this.mbarSubmit) this.mbarSubmit.addEventListener('click', () => this.#addToCart());
  }

  #bindClear() {
    if (this.clearBtn) this.clearBtn.addEventListener('click', () => {
      this.#selectedProducts.clear();
      this.#updateUI();
    });
  }

  #bindNavLinks() {
    for (const link of document.querySelectorAll('.bys__nav-link[href^="#"]')) {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const target = document.querySelector(link.getAttribute('href'));
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  #initReveals() {
    const els = document.querySelectorAll('.bys .reveal, .bys .rvg');
    if (!els.length) return;
    const obs = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          obs.unobserve(entry.target);
        }
      }
    }, { threshold: 0.15 });
    for (const el of els) obs.observe(el);
  }

  /* Largest package the catalog offers. Adding is capped here, not at the
     current tier, because exceeding the current tier promotes it instead. */
  #maxItems() {
    return CONFIG.tiers.reduce((n, t) => Math.max(n, t.items), 0);
  }

  /* The package follows the number of compounds chosen, so the price on screen
     always describes what is actually in the stack. Smallest tier that fits.
     A count of 0 leaves the tier alone - there is nothing to size to yet. */
  #fitTierToCount() {
    const count = this.#selectedProducts.size;
    if (count === 0) return;
    const fit = CONFIG.tiers
      .filter(t => t.items >= count)
      .sort((a, b) => a.items - b.items)[0];
    if (fit && fit.id !== (this.#selectedTier && this.#selectedTier.id)) {
      this.#selectTier(fit.id);
    }
  }

  #selectTier(tierId) {
    const tier = CONFIG.tiers.find(t => t.id === tierId);
    if (!tier) return;

    this.#selectedTier = tier;

    /* Picking a smaller package keeps the earliest choices rather than
       clearing the stack, so a mis-click does not cost the whole selection. */
    if (this.#selectedProducts.size > tier.items) {
      const keep = [...this.#selectedProducts].slice(0, tier.items);
      this.#selectedProducts.clear();
      for (const [vid, title] of keep) this.#selectedProducts.set(vid, title);
    }

    for (const el of this.tierEls) {
      el.setAttribute('aria-pressed', parseInt(el.dataset.tier, 10) === tierId ? 'true' : 'false');
    }

    this.#updateUI();
  }

  /* fit=false is used once, for the ?product= handoff from a PDP, so the
     tier that arrived in the URL survives the first add. */
  #addProduct(variantId, title, fit = true) {
    if (!this.#selectedTier) return;
    if (this.#selectedProducts.has(variantId)) return;
    if (this.#selectedProducts.size >= this.#maxItems()) return;
    this.#selectedProducts.set(variantId, title);
    if (fit) this.#fitTierToCount();
    this.#updateUI();
  }

  #removeProduct(variantId) {
    if (!this.#selectedProducts.delete(variantId)) return;
    this.#fitTierToCount();
    this.#updateUI();
  }

  #updateUI() {
    const tier = this.#selectedTier;
    if (!tier) return;

    const count = this.#selectedProducts.size;
    const max = tier.items;
    const full = count >= max;
    const pct = max > 0 ? (count / max) * 100 : 0;

    this.errorEl.textContent = '';

    /* Nav counter */
    if (this.navCount) this.navCount.textContent = `${count}/${max}`;

    /* Status bar */
    this.statusFill.style.width = `${pct}%`;
    this.statusNum.textContent = count;
    this.statusMax.textContent = max;

    /* Compound cells */
    for (const cell of this.cells) {
      const vid = cell.dataset.variantId;
      const isSelected = this.#selectedProducts.has(vid);

      cell.setAttribute('aria-checked', isSelected ? 'true' : 'false');

      const selectBtn = cell.querySelector('.bys__cell-select');
      if (selectBtn) selectBtn.textContent = isSelected ? CONFIG.strings.selected : CONFIG.strings.select;

      const atCatalogMax = count >= this.#maxItems();
      if (atCatalogMax && !isSelected) {
        cell.classList.add('bys__cell--disabled');
      } else {
        cell.classList.remove('bys__cell--disabled');
      }
    }

    const remaining = max - count;

    /* Footer (if present) */
    if (this.footerLabel) {
      this.footerLabel.textContent = `Your stack / ${tier.name}`;
      this.footerPrice.textContent = tier.priceLabel;

      this.footerTags.innerHTML = '';
      for (const [vid, title] of this.#selectedProducts) {
        const tag = document.createElement('div');
        tag.className = 'bys__footer-tag';
        tag.innerHTML = `<span class="bys__footer-tag-name">${this.#escapeHTML(title)}</span><button class="bys__footer-tag-remove" type="button" aria-label="Remove ${this.#escapeHTML(title)}">&#10005;</button>`;
        tag.querySelector('.bys__footer-tag-remove').addEventListener('click', (e) => {
          e.stopPropagation();
          this.#removeProduct(vid);
        });
        this.footerTags.appendChild(tag);
      }

      for (let i = 0; i < remaining; i++) {
        const empty = document.createElement('div');
        empty.className = 'bys__footer-tag bys__footer-tag--empty';
        empty.innerHTML = `<span class="bys__footer-tag-name">+ Choose ${remaining - i} more</span>`;
        this.footerTags.appendChild(empty);
      }
    }

    /* Sidebar widget */
    if (this.widgetSlots) {
      this.widgetTier.textContent = tier.name;
      this.widgetCount.textContent = CONFIG.strings.widgetCount.replace('[count]', count).replace('[max]', max);
      this.widgetPrice.textContent = tier.priceLabel;

      this.widgetSlots.innerHTML = '';
      for (const [vid, title] of this.#selectedProducts) {
        const slot = document.createElement('div');
        slot.className = 'bys__widget-slot';
        slot.innerHTML = `${this.#escapeHTML(title)}<button class="bys__widget-slot-remove" type="button" aria-label="Remove ${this.#escapeHTML(title)}">&#10005;</button>`;
        slot.querySelector('.bys__widget-slot-remove').addEventListener('click', () => this.#removeProduct(vid));
        this.widgetSlots.appendChild(slot);
      }
      for (let i = 0; i < remaining; i++) {
        const empty = document.createElement('div');
        empty.className = 'bys__widget-slot bys__widget-slot--empty';
        empty.textContent = CONFIG.strings.slot.replace('[n]', count + i + 1);
        this.widgetSlots.appendChild(empty);
      }
      this.widgetSubmit.disabled = !full;
    }

    /* Mobile bar */
    if (this.mbarTier) {
      this.mbarTier.textContent = tier.name;
      this.mbarCount.textContent = CONFIG.strings.mobileCount.replace('[count]', count).replace('[max]', max);
      this.mbarPrice.textContent = tier.priceLabel;
      this.mbarSubmit.disabled = !full;
    }
    if (this.mbarItems) {
      this.mbarItems.innerHTML = '';
      for (const [, title] of this.#selectedProducts) {
        const item = document.createElement('span');
        item.className = 'bys__mobile-bar-item';
        item.textContent = title;
        this.mbarItems.appendChild(item);
      }
    }

    /* Submit button */
    if (this.submitBtn) this.submitBtn.disabled = !full;
  }

  async #addToCart() {
    const tier = this.#selectedTier;
    if (!tier) return;
    if (this.#selectedProducts.size < tier.items) return;

    const _vid = parseInt(tier.variantId, 10);
    const _spid = parseInt(CONFIG.sellingPlanId, 10);
    if (!Number.isFinite(_vid) || !Number.isFinite(_spid)) {
      if (this.errorEl) this.errorEl.textContent = `${CONFIG.strings.errorPrefix} This stack is not configured for checkout yet.`;
      return;
    }

    const btns = [this.submitBtn, this.widgetSubmit, this.mbarSubmit].filter(Boolean);
    btns.forEach(b => { b.disabled = true; b.textContent = CONFIG.strings.submitLoading; });

    const properties = { _isClassicBoxV2: true };

    for (const [vid, title] of this.#selectedProducts) {
      properties[title] = 1;
      properties[`_pvgid://shopify/ProductVariant/${vid}`] = 1;
    }

    const payload = {
      items: [{
        quantity: 1,
        id: _vid,
        selling_plan: _spid,
        properties: properties
      }]
    };

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const err = await response.json();
        throw new Error(err.description || 'Failed to add to cart');
      }

      window.location.href = CONFIG.cartRedirect;
    } catch (error) {
      console.error('Build Your Stack - cart error:', error);
      btns.forEach(b => { b.disabled = false; b.textContent = CONFIG.strings.submit; });
      if (this.errorEl) this.errorEl.textContent = `${CONFIG.strings.errorPrefix} ${error.message}`;
    }
  }

  #escapeHTML(str) {
    const el = document.createElement('span');
    el.textContent = str;
    return el.innerHTML;
  }
}

function bysBoot() {
  const root = document.getElementById('build-your-stack');
  if (!root) return;
  CONFIG = bysReadConfig(root);
  new BuildYourStack();
}

document.addEventListener('DOMContentLoaded', bysBoot);
/* Theme editor swaps the section DOM without a page load. Old nodes and
   their listeners die with it, so re-init rather than double-bind. */
document.addEventListener('shopify:section:load', (e) => {
  if (e.target && e.target.querySelector && e.target.querySelector('#build-your-stack')) bysBoot();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["injectable-catalog"] && !Shopify.designMode) return;
  try {
    
(function() {
  var roots = document.querySelectorAll('[data-ic-catalog]');
  roots.forEach(function(root) {
    var grid = root.querySelector('[data-ic-grid]');
    var tabs = root.querySelectorAll('[data-ic-category]');

    function setCategory(cat) {
      if (!grid) return;
      grid.setAttribute('data-ic-filter', cat);
      grid.querySelectorAll('[data-ic-card]').forEach(function(card) {
        var match = (cat === 'all') || (card.getAttribute('data-ic-cat') === cat);
        if (match) card.setAttribute('data-ic-cat-match', '');
        else card.removeAttribute('data-ic-cat-match');
      });
      tabs.forEach(function(t) {
        var on = t.getAttribute('data-ic-category') === cat;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        setCategory(tab.getAttribute('data-ic-category'));
      });
    });

    // Initialize to first tab
    if (tabs[0]) setCategory(tabs[0].getAttribute('data-ic-category'));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ivuse-recommendation-pdp"] && !Shopify.designMode) return;
  try {
    

(function() {
  'use strict';

  var CONFIG = window.__IVUSE_SECTION_CONFIG__ || {};

  var DURATION = {
    '2mo': {
      label:    CONFIG.label2mo    || '2 Months',
      price:    CONFIG.price2mo    || 0,
      perMonth: CONFIG.perMonth2mo || 0,
      doses:    CONFIG.doses2mo    || []
    },
    '3mo': {
      label:    CONFIG.label3mo    || '3 Months',
      price:    CONFIG.price3mo    || 0,
      perMonth: CONFIG.perMonth3mo || 0,
      doses:    CONFIG.doses3mo    || []
    }
  };

  var medLabel = CONFIG.medLabel || '';
  var activeDuration = '2mo';

  function getVariantId(durationKey) {
    var variants = window.__IVUSE_VARIANTS__ || [];
    var targetOption = DURATION[durationKey].label;
    var match = variants.find(function(v) {
      return v.option1 === targetOption || v.title === targetOption;
    });
    return match ? match.id : null;
  }

  function buildDosingHtml(doses) {
    return doses.map(function(dose, i) {
      var html = i > 0 ? '<div class="ivuse-pdp__dosing-arrow" aria-hidden="true">&rarr;</div>' : '';
      html += '<div class="ivuse-pdp__dosing-month">';
      html += '<div class="ivuse-pdp__dosing-value">' + dose + '</div>';
      html += '<div class="ivuse-pdp__dosing-month-label">Month ' + (i + 1) + '</div>';
      html += '</div>';
      return html;
    }).join('');
  }

  function updateDisplay() {
    var dur     = DURATION[activeDuration];
    var subname = document.getElementById('ivuse-subname');
    var price   = document.getElementById('ivuse-price');
    var per     = document.getElementById('ivuse-price-per');
    var dLabel  = document.getElementById('ivuse-dosing-label');
    var dRow    = document.getElementById('ivuse-dosing-row');
    var varInput = document.getElementById('ivuse-variant-input');
    if (subname) subname.textContent = medLabel + ' // ' + dur.label;
    if (price)   price.textContent   = '$' + dur.price + '.00';
    if (per)     per.textContent     = '$' + dur.perMonth + '/month';
    if (dLabel)  dLabel.textContent  = dur.label + ' Protocol';
    if (dRow)    dRow.innerHTML      = buildDosingHtml(dur.doses);
    // Keep hidden variant input in sync so Infinite Options sees the right variant
    var vid = getVariantId(activeDuration);
    if (varInput && vid) varInput.value = vid;
  }

  window.ivusePdp = {

    setImage: function(thumb, index) {
      var images = window.__IVUSE_IMAGES__ || [];
      var img = images[index];
      if (!img) return;
      var main = document.getElementById('ivuse-gallery-main');
      if (main) {
        main.classList.add('is-loading');
        var loader = new Image();
        loader.onload = function() {
          main.src = img.src;
          main.alt = img.alt || '';
          main.classList.remove('is-loading');
        };
        loader.src = img.src;
      }
      document.querySelectorAll('.ivuse-pdp__gallery-thumb').forEach(function(t) {
        t.classList.remove('ivuse-pdp__gallery-thumb--active');
        t.setAttribute('aria-pressed', 'false');
      });
      thumb.classList.add('ivuse-pdp__gallery-thumb--active');
      thumb.setAttribute('aria-pressed', 'true');
    },

    pickDuration: function(el, dur) {
      document.querySelectorAll('.ivuse-pdp__size-btn').forEach(function(b) {
        b.classList.remove('ivuse-pdp__size-btn--active');
        b.setAttribute('aria-pressed', 'false');
      });
      el.classList.add('ivuse-pdp__size-btn--active');
      el.setAttribute('aria-pressed', 'true');
      activeDuration = dur;
      updateDisplay();
    },

    proceedToCheckout: function(e) {
      if (e) e.preventDefault();
      var btn = document.getElementById('ivuse-cta');
      var variantId = getVariantId(activeDuration);
      if (!variantId) {
        console.error('IVUSE PDP: No variant found for duration "' + activeDuration + '"');
        return;
      }
      if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
      .then(function(res) { return res.json(); })
      .then(function() { window.location.href = '/checkout'; })
      .catch(function() {
        if (btn) { btn.textContent = 'Proceed to Checkout'; btn.disabled = false; }
        window.location.href = '/cart/' + variantId + ':1';
      });
    },

    toggleCollapse: function(id) {
      var wrapper = document.getElementById(id);
      if (!wrapper) return;
      var body    = wrapper.querySelector('.ivuse-pdp__collapse-body');
      var trigger = wrapper.querySelector('.ivuse-pdp__collapse-trigger');
      var isOpen  = wrapper.classList.contains('ivuse-pdp__collapse--open');
      if (isOpen) {
        wrapper.classList.remove('ivuse-pdp__collapse--open');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (body)    body.hidden = true;
      } else {
        wrapper.classList.add('ivuse-pdp__collapse--open');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
        if (body)    body.hidden = false;
      }
    },

    toggleFaq: function(btn) {
      var item   = btn.closest('.ivuse-faq__item');
      var answer = item ? item.querySelector('.ivuse-faq__answer') : null;
      var isOpen = item && item.classList.contains('ivuse-faq__item--open');
      document.querySelectorAll('.ivuse-faq__item').forEach(function(i) {
        i.classList.remove('ivuse-faq__item--open');
        var a = i.querySelector('.ivuse-faq__answer');
        var b = i.querySelector('.ivuse-faq__question');
        if (a) a.hidden = true;
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen && item && answer) {
        item.classList.add('ivuse-faq__item--open');
        answer.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
      }
    },

    openPopup: function(e) {
      if (e) e.preventDefault();
      var popup   = document.getElementById('ivuse-popup');
      var overlay = document.getElementById('ivuse-popup-overlay');
      if (popup)   popup.hidden   = false;
      if (overlay) overlay.hidden = false;
      document.body.style.overflow = 'hidden';
    },

    closePopup: function() {
      var popup   = document.getElementById('ivuse-popup');
      var overlay = document.getElementById('ivuse-popup-overlay');
      if (popup)   popup.hidden   = true;
      if (overlay) overlay.hidden = true;
      document.body.style.overflow = '';
    }
  };

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') ivusePdp.closePopup();
  });

  updateDisplay();

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peptide-pdp-v3"] && !Shopify.designMode) return;
  try {
    
// Scroll reveal
var revealEls = document.querySelectorAll('.tesa-reveal');
var revealObs = new IntersectionObserver(function(entries) {
  entries.forEach(function(e) {
    if (e.isIntersecting) {
      e.target.classList.add('visible');
      revealObs.unobserve(e.target);
    }
  });
}, { threshold: 0.06, rootMargin: '0px 0px -40px 0px' });
revealEls.forEach(function(el) { revealObs.observe(el); });

// Tabs
document.querySelectorAll('.tesa-tab-btn').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var t = btn.dataset.tab;
    document.querySelectorAll('.tesa-tab-btn').forEach(function(b) { b.classList.remove('active'); b.setAttribute('aria-selected','false'); });
    document.querySelectorAll('.tesa-tab-panel').forEach(function(p) { p.classList.remove('active'); });
    btn.classList.add('active');
    btn.setAttribute('aria-selected','true');
    document.getElementById('tesa-tab-' + t).classList.add('active');
  });
});

// Gallery thumbnails
document.querySelectorAll('.tesa-hero__thumb').forEach(function(thumb) {
  thumb.addEventListener('click', function() {
    var mainImg = document.getElementById('tesa-hero-main-img');
    if (mainImg) {
      mainImg.src = thumb.dataset.imgSrc;
      mainImg.alt = thumb.dataset.imgAlt;
    }
    document.querySelectorAll('.tesa-hero__thumb').forEach(function(t) { t.classList.remove('active'); });
    thumb.classList.add('active');
  });
});

// Variant selector (radio cards)
var variantCards = document.querySelectorAll('.tesa-variant-card');
var ctaLabel = document.getElementById('tesa-cta-label');
variantCards.forEach(function(card) {
  var radio = card.querySelector('input[type="radio"]');
  if (radio) {
    radio.addEventListener('change', function() {
      variantCards.forEach(function(c) { c.classList.remove('is-selected'); });
      card.classList.add('is-selected');
      var variantId = radio.value;
      // Update CTA label from data attribute
      if (ctaLabel && card.dataset.ctaLabel) {
        var price = card.dataset.variantPrice;
        var labelText = card.dataset.ctaLabel + (price ? ' — ' + price : '');
        ctaLabel.textContent = labelText;
      }
      // Update final CTA label
      var finalCtaLabel = document.querySelector('.tesa-final-cta-label');
      if (finalCtaLabel && card.dataset.variantPrice) {
        finalCtaLabel.textContent = card.dataset.ctaLabel + ' — ' + card.dataset.variantPrice;
      }
      // Update sticky + final CTA hidden inputs
      var stickyInput = document.getElementById('tesa-sticky-variant-id');
      if (stickyInput) stickyInput.value = variantId;
      document.querySelectorAll('.tesa-final-cta input[name="id"]').forEach(function(input) {
        input.value = variantId;
      });
    });
  }
});

// Sticky CTA
var heroCta = document.getElementById('tesa-hero-cta');
var finalCta = document.getElementById('tesa-final-cta');
var stickyCta = document.getElementById('tesa-sticky-cta');
if (heroCta && finalCta && stickyCta) {
  var stickyObs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.target === heroCta) {
        if (!e.isIntersecting) stickyCta.classList.add('visible');
        else stickyCta.classList.remove('visible');
      }
      if (e.target === finalCta && e.isIntersecting) {
        stickyCta.classList.remove('visible');
      }
    });
  }, { threshold: 0 });
  stickyObs.observe(heroCta);
  stickyObs.observe(finalCta);
}

/* ── AJAX Add to Cart for Protocol Companions ── */
document.querySelectorAll('.tesa-pairing__atc[data-variant-id]').forEach(function(btn) {
  btn.addEventListener('click', function(e) {
    e.preventDefault();
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    btn.classList.add('is-adding');
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
    .then(function(res) { return res.json(); })
    .then(function() {
      btn.classList.remove('is-adding');
      btn.classList.add('is-added');
      btn.textContent = 'Added to Cart';

      /* Update cart count in Pipeline header */
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var countEls = document.querySelectorAll('.js-cart-count, .cart__count, [data-cart-count]');
          countEls.forEach(function(el) { el.textContent = cart.item_count; });
        });

      setTimeout(function() {
        btn.classList.remove('is-added');
        btn.textContent = 'Add to Cart';
      }, 2500);
    })
    .catch(function() {
      btn.classList.remove('is-adding');
      btn.textContent = 'Error — Try Again';
      setTimeout(function() { btn.textContent = 'Add to Cart'; }, 2000);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peptide-pdp-v4"] && !Shopify.designMode) return;
  try {
    
// Scroll reveal
var revealEls = document.querySelectorAll('.tesa-reveal');
var revealObs = new IntersectionObserver(function(entries) {
  entries.forEach(function(e) {
    if (e.isIntersecting) {
      e.target.classList.add('visible');
      revealObs.unobserve(e.target);
    }
  });
}, { threshold: 0.06, rootMargin: '0px 0px -40px 0px' });
revealEls.forEach(function(el) { revealObs.observe(el); });

// Tabs
document.querySelectorAll('.tesa-tab-btn').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var t = btn.dataset.tab;
    document.querySelectorAll('.tesa-tab-btn').forEach(function(b) { b.classList.remove('active'); b.setAttribute('aria-selected','false'); });
    document.querySelectorAll('.tesa-tab-panel').forEach(function(p) { p.classList.remove('active'); });
    btn.classList.add('active');
    btn.setAttribute('aria-selected','true');
    document.getElementById('tesa-tab-' + t).classList.add('active');
  });
});

// Gallery thumbnails
document.querySelectorAll('.tesa-hero__thumb').forEach(function(thumb) {
  thumb.addEventListener('click', function() {
    var mainImg = document.getElementById('tesa-hero-main-img');
    if (mainImg) {
      mainImg.src = thumb.dataset.imgSrc;
      mainImg.alt = thumb.dataset.imgAlt;
    }
    document.querySelectorAll('.tesa-hero__thumb').forEach(function(t) { t.classList.remove('active'); });
    thumb.classList.add('active');
  });
});

// Variant selector (radio cards)
var variantCards = document.querySelectorAll('.tesa-variant-card');
var ctaLabel = document.getElementById('tesa-cta-label');
variantCards.forEach(function(card) {
  var radio = card.querySelector('input[type="radio"]');
  if (radio) {
    radio.addEventListener('change', function() {
      variantCards.forEach(function(c) { c.classList.remove('is-selected'); });
      card.classList.add('is-selected');
      var variantId = radio.value;
      // Update CTA label from data attribute
      if (ctaLabel && card.dataset.ctaLabel) {
        var price = card.dataset.variantPrice;
        var labelText = card.dataset.ctaLabel + (price ? ' — ' + price : '');
        ctaLabel.textContent = labelText;
      }
      // Update final CTA label
      var finalCtaLabel = document.querySelector('.tesa-final-cta-label');
      if (finalCtaLabel && card.dataset.variantPrice) {
        finalCtaLabel.textContent = card.dataset.ctaLabel + ' — ' + card.dataset.variantPrice;
      }
      // Update the buy-box price row (price, compare-at anchor, savings)
      var priceNow = document.getElementById('tesa-price-now');
      var priceWas = document.getElementById('tesa-price-was');
      var priceSave = document.getElementById('tesa-price-save');
      if (priceNow && card.dataset.variantPrice) {
        priceNow.textContent = card.dataset.variantPrice;
      }
      if (priceWas) {
        var cmp = card.dataset.variantCompare || '';
        priceWas.textContent = cmp;
        priceWas.hidden = !cmp;
      }
      if (priceSave) {
        var sav = card.dataset.variantSave || '';
        priceSave.textContent = sav ? 'Save ' + sav : '';
        priceSave.hidden = !sav;
      }
      // Update sticky CTA price + hidden input
      var stickyInput = document.getElementById('tesa-sticky-variant-id');
      if (stickyInput) stickyInput.value = variantId;
      var stickyPrice = document.getElementById('tesa-sticky-price');
      if (stickyPrice && card.dataset.variantPrice) {
        stickyPrice.textContent = card.dataset.variantPrice;
      }
      document.querySelectorAll('.tesa-final-cta input[name="id"]').forEach(function(input) {
        input.value = variantId;
      });
    });
  }
});

// Sticky CTA
var heroCta = document.getElementById('tesa-hero-cta');
var finalCta = document.getElementById('tesa-final-cta');
var stickyCta = document.getElementById('tesa-sticky-cta');
if (heroCta && finalCta && stickyCta) {
  var stickyObs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.target === heroCta) {
        if (!e.isIntersecting) stickyCta.classList.add('visible');
        else stickyCta.classList.remove('visible');
      }
      if (e.target === finalCta && e.isIntersecting) {
        stickyCta.classList.remove('visible');
      }
    });
  }, { threshold: 0 });
  stickyObs.observe(heroCta);
  stickyObs.observe(finalCta);
}

/* ── AJAX Add to Cart for Protocol Companions ── */
document.querySelectorAll('.tesa-pairing__atc[data-variant-id]').forEach(function(btn) {
  btn.addEventListener('click', function(e) {
    e.preventDefault();
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    btn.classList.add('is-adding');
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
    .then(function(res) { return res.json(); })
    .then(function() {
      btn.classList.remove('is-adding');
      btn.classList.add('is-added');
      btn.textContent = 'Added to Cart';

      /* Update cart count in Pipeline header */
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var countEls = document.querySelectorAll('.js-cart-count, .cart__count, [data-cart-count]');
          countEls.forEach(function(el) { el.textContent = cart.item_count; });
        });

      setTimeout(function() {
        btn.classList.remove('is-added');
        btn.textContent = 'Add to Cart';
      }, 2500);
    })
    .catch(function() {
      btn.classList.remove('is-adding');
      btn.textContent = 'Error — Try Again';
      setTimeout(function() { btn.textContent = 'Add to Cart'; }, 2000);
    });
  });
});

/* ── AJAX Add to Cart for Sticky Mobile CTA ── */
var stickyForm = document.getElementById('tesa-sticky-form');
var stickyBtn = document.getElementById('tesa-sticky-btn');
if (stickyForm && stickyBtn) {
  stickyForm.addEventListener('submit', function(e) {
    e.preventDefault();
    var input = document.getElementById('tesa-sticky-variant-id');
    var variantId = input ? input.value : null;
    if (!variantId) return;

    stickyBtn.classList.add('is-adding');
    stickyBtn.textContent = 'Adding...';
    stickyBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
    .then(function(res) { return res.json(); })
    .then(function() {
      stickyBtn.classList.remove('is-adding');
      stickyBtn.classList.add('is-added');
      stickyBtn.textContent = 'Added to Cart';

      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var countEls = document.querySelectorAll('.js-cart-count, .cart__count, [data-cart-count]');
          countEls.forEach(function(el) { el.textContent = cart.item_count; });
        });

      setTimeout(function() {
        stickyBtn.classList.remove('is-added');
        stickyBtn.textContent = 'Add to Cart';
        stickyBtn.disabled = false;
      }, 2500);
    })
    .catch(function() {
      stickyBtn.classList.remove('is-adding');
      stickyBtn.textContent = 'Error — Try Again';
      setTimeout(function() {
        stickyBtn.textContent = 'Add to Cart';
        stickyBtn.disabled = false;
      }, 2000);
    });
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peptide-pdp-v6"] && !Shopify.designMode) return;
  try {
    
// Scroll reveal
var revealEls = document.querySelectorAll('.tesa-reveal');
var revealObs = new IntersectionObserver(function(entries) {
  entries.forEach(function(e) {
    if (e.isIntersecting) {
      e.target.classList.add('visible');
      revealObs.unobserve(e.target);
    }
  });
}, { threshold: 0.06, rootMargin: '0px 0px -40px 0px' });
revealEls.forEach(function(el) { revealObs.observe(el); });

// Tabs
document.querySelectorAll('.tesa-tab-btn').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var t = btn.dataset.tab;
    document.querySelectorAll('.tesa-tab-btn').forEach(function(b) { b.classList.remove('active'); b.setAttribute('aria-selected','false'); });
    document.querySelectorAll('.tesa-tab-panel').forEach(function(p) { p.classList.remove('active'); });
    btn.classList.add('active');
    btn.setAttribute('aria-selected','true');
    document.getElementById('tesa-tab-' + t).classList.add('active');
  });
});

// Gallery thumbnails
document.querySelectorAll('.tesa-hero__thumb').forEach(function(thumb) {
  thumb.addEventListener('click', function() {
    var mainImg = document.getElementById('tesa-hero-main-img');
    if (mainImg) {
      mainImg.src = thumb.dataset.imgSrc;
      mainImg.alt = thumb.dataset.imgAlt;
    }
    document.querySelectorAll('.tesa-hero__thumb').forEach(function(t) { t.classList.remove('active'); });
    thumb.classList.add('active');
  });
});

// Variant selector (radio cards)
var variantCards = document.querySelectorAll('.tesa-variant-card');
var ctaLabel = document.getElementById('tesa-cta-label');

// Build-a-Bundle behaves like a variant OPTION: selecting it just switches the buy box
// into "bundle mode" (fills its dot, points every CTA at the bundle page). It does NOT
// navigate — only pressing the CTA button advances to the bundle page. Picking a real
// variant hands the CTAs back to the cart.
var bundleCard = document.querySelector('[data-bundle-card]');
var stickyPriceEl = document.getElementById('tesa-sticky-price');
function setBundleMode(active) {
  if (!bundleCard) return;
  document.querySelectorAll('[data-bundle-cta]').forEach(function(el) { el.hidden = !active; });
  document.querySelectorAll('[data-variant-cta]').forEach(function(el) { el.hidden = active; });
  if (active) {
    variantCards.forEach(function(c) {
      c.classList.remove('is-selected');
      // Uncheck real variant radios so the radiogroup exposes a single checked option
      // (the bundle). The variant form is hidden in bundle mode so form validity is moot;
      // selectVariant re-checks a radio the moment a real variant is picked.
      var r = c.querySelector('input[type="radio"]');
      if (r) r.checked = false;
    });
    bundleCard.classList.add('is-selected');
    bundleCard.setAttribute('aria-checked', 'true');
    // Re-selecting the bundle after a variant was chosen: restore the bundle price line.
    if (stickyPriceEl && bundleCard.dataset.bundlePrice) {
      stickyPriceEl.textContent = bundleCard.dataset.bundlePrice;
    }
  } else {
    bundleCard.classList.remove('is-selected');
    bundleCard.setAttribute('aria-checked', 'false');
  }
}
if (bundleCard) {
  bundleCard.addEventListener('click', function() { setBundleMode(true); });
}

function selectVariant(card, radio) {
  if (radio.disabled) return;
  // When the bundle is the default choice the first real variant is already `checked`,
  // so a click on its label fires no `change` event. Drive selection from `click` too and
  // set `checked` explicitly so the already-checked case still activates variant mode.
  radio.checked = true;
  setBundleMode(false);
  variantCards.forEach(function(c) { c.classList.remove('is-selected'); });
  card.classList.add('is-selected');
  var variantId = radio.value;
  // selectVariant only runs for enabled radios, so the chosen variant is in stock.
  // Re-enable the three submit buttons in case the page first loaded on a sold-out
  // variant (deep link), which renders them disabled with a "Sold Out" label.
  ['tesa-hero-cta', 'tesa-sticky-btn'].forEach(function(id) {
    var b = document.getElementById(id);
    if (b) b.disabled = false;
  });
  var finalBtn = document.querySelector('.tesa-final-cta button[type="submit"]');
  if (finalBtn) finalBtn.disabled = false;
  // Update hero CTA label from data attribute
  if (ctaLabel && card.dataset.ctaLabel) {
    var price = card.dataset.variantPrice;
    var labelText = card.dataset.ctaLabel + (price ? ' — ' + price : '');
    ctaLabel.textContent = labelText;
  }
  // Update final CTA label
  var finalCtaLabel = document.querySelector('.tesa-final-cta-label');
  if (finalCtaLabel && card.dataset.variantPrice) {
    finalCtaLabel.textContent = card.dataset.ctaLabel + ' — ' + card.dataset.variantPrice;
  }
  // Update sticky CTA price + hidden input
  var stickyInput = document.getElementById('tesa-sticky-variant-id');
  if (stickyInput) stickyInput.value = variantId;
  var stickyPrice = document.getElementById('tesa-sticky-price');
  if (stickyPrice && card.dataset.variantPrice) {
    stickyPrice.textContent = card.dataset.variantPrice;
  }
  document.querySelectorAll('.tesa-final-cta input[name="id"]').forEach(function(input) {
    input.value = variantId;
  });
}

variantCards.forEach(function(card) {
  var radio = card.querySelector('input[type="radio"]');
  if (!radio) return;
  // `click` catches selecting an already-checked radio (bundle-default → single variant);
  // `change` catches keyboard arrow navigation between radios. The handler is idempotent,
  // so the two firing together on a normal variant-to-variant switch is harmless.
  radio.addEventListener('click', function() { selectVariant(card, radio); });
  radio.addEventListener('change', function() { selectVariant(card, radio); });
});

// Align JS state with the server-rendered initial selection. When the bundle loads
// selected, this unchecks the form's placeholder radio so the radiogroup is single-checked.
if (bundleCard && bundleCard.classList.contains('is-selected')) {
  setBundleMode(true);
}

// Sticky CTA
// Observe the wrapper, not the button: the button is hidden while the bundle is active
// and a hidden element never intersects, which would pin the sticky bar open.
var heroCta = document.getElementById('tesa-hero-cta-wrap') || document.getElementById('tesa-hero-cta');
var finalCta = document.getElementById('tesa-final-cta');
var stickyCta = document.getElementById('tesa-sticky-cta');
if (heroCta && finalCta && stickyCta) {
  var stickyObs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.target === heroCta) {
        if (!e.isIntersecting) stickyCta.classList.add('visible');
        else stickyCta.classList.remove('visible');
      }
      if (e.target === finalCta && e.isIntersecting) {
        stickyCta.classList.remove('visible');
      }
    });
  }, { threshold: 0 });
  stickyObs.observe(heroCta);
  stickyObs.observe(finalCta);
}

/* ── AJAX Add to Cart for Protocol Companions ── */
document.querySelectorAll('.tesa-pairing__atc[data-variant-id]').forEach(function(btn) {
  btn.addEventListener('click', function(e) {
    e.preventDefault();
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    btn.classList.add('is-adding');
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
    .then(function(res) { return res.json(); })
    .then(function() {
      btn.classList.remove('is-adding');
      btn.classList.add('is-added');
      btn.textContent = 'Added to Cart';

      /* Update cart count in Pipeline header */
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var countEls = document.querySelectorAll('.js-cart-count, .cart__count, [data-cart-count]');
          countEls.forEach(function(el) { el.textContent = cart.item_count; });
        });

      setTimeout(function() {
        btn.classList.remove('is-added');
        btn.textContent = 'Add to Cart';
      }, 2500);
    })
    .catch(function() {
      btn.classList.remove('is-adding');
      btn.textContent = 'Error — Try Again';
      setTimeout(function() { btn.textContent = 'Add to Cart'; }, 2000);
    });
  });
});

/* ── AJAX Add to Cart for Sticky Mobile CTA ── */
var stickyForm = document.getElementById('tesa-sticky-form');
var stickyBtn = document.getElementById('tesa-sticky-btn');
if (stickyForm && stickyBtn) {
  stickyForm.addEventListener('submit', function(e) {
    e.preventDefault();
    var input = document.getElementById('tesa-sticky-variant-id');
    var variantId = input ? input.value : null;
    if (!variantId) return;

    stickyBtn.classList.add('is-adding');
    stickyBtn.textContent = 'Adding...';
    stickyBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
    .then(function(res) { return res.json(); })
    .then(function() {
      stickyBtn.classList.remove('is-adding');
      stickyBtn.classList.add('is-added');
      stickyBtn.textContent = 'Added to Cart';

      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var countEls = document.querySelectorAll('.js-cart-count, .cart__count, [data-cart-count]');
          countEls.forEach(function(el) { el.textContent = cart.item_count; });
        });

      setTimeout(function() {
        stickyBtn.classList.remove('is-added');
        stickyBtn.textContent = 'Add to Cart';
        stickyBtn.disabled = false;
      }, 2500);
    })
    .catch(function() {
      stickyBtn.classList.remove('is-adding');
      stickyBtn.textContent = 'Error — Try Again';
      setTimeout(function() {
        stickyBtn.textContent = 'Add to Cart';
        stickyBtn.disabled = false;
      }, 2000);
    });
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peptide-stack-pdp-v1"] && !Shopify.designMode) return;
  try {
    
// Scroll reveal
var revealEls = document.querySelectorAll('.tesa-reveal');
var revealObs = new IntersectionObserver(function(entries) {
  entries.forEach(function(e) {
    if (e.isIntersecting) {
      e.target.classList.add('visible');
      revealObs.unobserve(e.target);
    }
  });
}, { threshold: 0.06, rootMargin: '0px 0px -40px 0px' });
revealEls.forEach(function(el) { revealObs.observe(el); });

// Tabs
document.querySelectorAll('.tesa-tab-btn').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var t = btn.dataset.tab;
    document.querySelectorAll('.tesa-tab-btn').forEach(function(b) { b.classList.remove('active'); b.setAttribute('aria-selected','false'); });
    document.querySelectorAll('.tesa-tab-panel').forEach(function(p) { p.classList.remove('active'); });
    btn.classList.add('active');
    btn.setAttribute('aria-selected','true');
    document.getElementById('tesa-tab-' + t).classList.add('active');
  });
});

// Variant selector (radio cards)
var variantCards = document.querySelectorAll('.tesa-variant-card');
var ctaLabel = document.getElementById('tesa-cta-label');
variantCards.forEach(function(card) {
  var radio = card.querySelector('input[type="radio"]');
  if (radio) {
    radio.addEventListener('change', function() {
      variantCards.forEach(function(c) { c.classList.remove('is-selected'); });
      card.classList.add('is-selected');
      var variantId = radio.value;
      if (ctaLabel && card.dataset.ctaLabel) {
        var price = card.dataset.variantPrice;
        var labelText = card.dataset.ctaLabel + (price ? ' — ' + price : '');
        ctaLabel.textContent = labelText;
      }
      var finalCtaLabel = document.querySelector('.tesa-final-cta-label');
      if (finalCtaLabel && card.dataset.variantPrice) {
        finalCtaLabel.textContent = card.dataset.ctaLabel + ' — ' + card.dataset.variantPrice;
      }
      var stickyInput = document.getElementById('tesa-sticky-variant-id');
      if (stickyInput) stickyInput.value = variantId;
      document.querySelectorAll('.tesa-final-cta input[name="id"]').forEach(function(input) {
        input.value = variantId;
      });
    });
  }
});

// Sticky CTA
var heroCta = document.getElementById('tesa-hero-cta');
var finalCta = document.getElementById('tesa-final-cta');
var stickyCta = document.getElementById('tesa-sticky-cta');
if (heroCta && finalCta && stickyCta) {
  var stickyObs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.target === heroCta) {
        if (!e.isIntersecting) stickyCta.classList.add('visible');
        else stickyCta.classList.remove('visible');
      }
      if (e.target === finalCta && e.isIntersecting) {
        stickyCta.classList.remove('visible');
      }
    });
  }, { threshold: 0 });
  stickyObs.observe(heroCta);
  stickyObs.observe(finalCta);
}

// AJAX Add to Cart for cross-sell companions
document.querySelectorAll('.tesa-pairing__atc[data-variant-id]').forEach(function(btn) {
  btn.addEventListener('click', function(e) {
    e.preventDefault();
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    btn.classList.add('is-adding');
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
    .then(function(res) { return res.json(); })
    .then(function() {
      btn.classList.remove('is-adding');
      btn.classList.add('is-added');
      btn.textContent = 'Added to Cart';

      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var countEls = document.querySelectorAll('.js-cart-count, .cart__count, [data-cart-count]');
          countEls.forEach(function(el) { el.textContent = cart.item_count; });
        });

      setTimeout(function() {
        btn.classList.remove('is-added');
        btn.textContent = 'Add to Cart';
      }, 2500);
    })
    .catch(function() {
      btn.classList.remove('is-adding');
      btn.textContent = 'Error - Try Again';
      setTimeout(function() { btn.textContent = 'Add to Cart'; }, 2000);
    });
  });
});

// Hero carousel
(function() {
  var carousel = document.getElementById('tesa-hero-carousel');
  if (!carousel) return;
  var track = document.getElementById('tesa-hero-track');
  if (!track) return;
  var slides = Array.prototype.slice.call(track.querySelectorAll('.tesa-hero__slide'));
  if (slides.length < 2) return;

  var prev = document.getElementById('tesa-hero-prev');
  var next = document.getElementById('tesa-hero-next');
  var dots = Array.prototype.slice.call(carousel.querySelectorAll('.tesa-hero__dot'));
  var current = 0;

  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function goTo(i) {
    if (i < 0) i = 0;
    if (i > slides.length - 1) i = slides.length - 1;
    track.scrollTo({
      left: slides[i].offsetLeft,
      behavior: reduceMotion() ? 'auto' : 'smooth'
    });
  }

  function setActive(i) {
    current = i;
    dots.forEach(function(dot, di) {
      var active = di === i;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    if (prev) prev.disabled = i === 0;
    if (next) next.disabled = i === slides.length - 1;
  }

  if (prev) prev.addEventListener('click', function() { goTo(current - 1); });
  if (next) next.addEventListener('click', function() { goTo(current + 1); });

  dots.forEach(function(dot) {
    dot.addEventListener('click', function() {
      var idx = parseInt(dot.getAttribute('data-index'), 10);
      if (!isNaN(idx)) goTo(idx);
    });
  });

  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
        var idx = slides.indexOf(entry.target);
        if (idx >= 0 && idx !== current) setActive(idx);
      }
    });
  }, { root: track, threshold: [0.6] });
  slides.forEach(function(s) { io.observe(s); });

  carousel.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
    else if (e.key === 'Home') { e.preventDefault(); goTo(0); }
    else if (e.key === 'End') { e.preventDefault(); goTo(slides.length - 1); }
  });

  setActive(0);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tesamorelin-rebuild"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  // ========================================================================
  // SCROLL REVEAL HANDLER
  // ========================================================================
  const revealElements = document.querySelectorAll('.ivt-rv');

  if (revealElements.length > 0 && 'IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          revealObserver.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    revealElements.forEach((element) => {
      revealObserver.observe(element);
    });
  } else {
    // Fallback: show all elements immediately if no IntersectionObserver
    revealElements.forEach((element) => {
      element.classList.add('is-revealed');
    });
  }

  // ========================================================================
  // STICKY CTA HANDLER
  // ========================================================================
  const stickyCta = document.querySelector('.ivt-sticky-cta');
  const heroCta = document.querySelector('.ivt-hero__cta');
  const finalCta = document.querySelector('.ivt-final-cta');

  if (stickyCta && heroCta && finalCta) {
    const stickyObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        // Show sticky CTA when hero CTA is out of view
        if (!entry.isIntersecting && entry.target === heroCta) {
          stickyCta.classList.add('is-visible');
        }
      });
    }, {
      threshold: 0
    });

    const finalObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        // Hide sticky CTA when final CTA enters view
        if (entry.isIntersecting && entry.target === finalCta) {
          stickyCta.classList.remove('is-visible');
        } else if (!entry.isIntersecting && entry.target === finalCta) {
          stickyCta.classList.add('is-visible');
        }
      });
    }, {
      threshold: 0.1
    });

    stickyObserver.observe(heroCta);
    finalObserver.observe(finalCta);
  }

  // ========================================================================
  // ACCORDION BEHAVIOR (MOBILE)
  // ========================================================================
  const isMobile = window.innerWidth <= 768;

  const productDataBlocks = document.querySelectorAll('.ivt-product-data__block');
  const faqItems = document.querySelectorAll('.ivt-faq__item');

  if (isMobile) {
    // On mobile, close all details initially, then add event listeners
    productDataBlocks.forEach((block) => {
      block.open = false;
      block.addEventListener('toggle', (e) => {
        if (e.target.open) {
          // Close other blocks when one opens
          productDataBlocks.forEach((otherBlock) => {
            if (otherBlock !== e.target) {
              otherBlock.open = false;
            }
          });
        }
      });
    });

    faqItems.forEach((item) => {
      item.open = false;
      item.addEventListener('toggle', (e) => {
        if (e.target.open) {
          // Close other items when one opens
          faqItems.forEach((otherItem) => {
            if (otherItem !== e.target) {
              otherItem.open = false;
            }
          });
        }
      });
    });
  } else {
    // On desktop, keep all details open
    productDataBlocks.forEach((block) => {
      block.open = true;
    });

    faqItems.forEach((item) => {
      item.open = true;
    });
  }

  // Handle window resize
  window.addEventListener('resize', () => {
    const nowMobile = window.innerWidth <= 768;
    if (nowMobile && !isMobile) {
      productDataBlocks.forEach((block) => { block.open = false; });
      faqItems.forEach((item) => { item.open = false; });
    } else if (!nowMobile && isMobile) {
      productDataBlocks.forEach((block) => { block.open = true; });
      faqItems.forEach((item) => { item.open = true; });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiz-results"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const params = new URL(window.location.href).searchParams;
    const type = params.get('type');
    const frustration = params.get('frustration');
    const trust = params.get('trust');
    const peptideHistory = params.get('peptide_history');

    const loading = document.getElementById('qr-loading');
    const error = document.getElementById('qr-error');
    const results = document.getElementById('qr-results');

    /* Validate */
    if (!type || !['dry', 'combo', 'mature', 'sensitive'].includes(type)) {
      loading.hidden = true;
      error.hidden = false;
      return;
    }

    /* Helper: reveal ALL elements matching a selector */
    function revealAll(selector) {
      const els = document.querySelectorAll(selector);
      for (const el of els) el.hidden = false;
    }

    /* Type labels */
    const LABELS = {
      dry: 'Dry / Dehydrated',
      combo: 'Combination / Oily',
      mature: 'Normal / Mature',
      sensitive: 'Sensitive / Reactive'
    };

    /* S1 + S3: Skin type (text + images in both sections) */
    document.getElementById('skin-type-label').textContent = LABELS[type];
    revealAll('[data-type="' + type + '"]');
    revealAll('[data-personal="' + type + '"]');

    /* S2: Peptide history callout */
    if (peptideHistory === 'yes') {
      revealAll('[data-show="peptide-history"]');
    }

    /* S4: Frustration (text + image) */
    if (frustration) {
      revealAll('[data-frustration="' + frustration + '"]');
    }

    /* S5: Trust (text + image, nested inside the trust div) */
    if (trust) {
      revealAll('[data-trust="' + trust + '"]');
    }

    /* Swap states */
    loading.hidden = true;
    results.hidden = false;

    /* Scroll reveal observer */
    const reveals = document.querySelectorAll('.qr__reveal');
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(function (entries) {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('qr__reveal--visible');
            observer.unobserve(entry.target);
          }
        }
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

      for (const el of reveals) {
        observer.observe(el);
      }
    } else {
      for (const el of reveals) {
        el.classList.add('qr__reveal--visible');
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tesamorelin-pdp"] && !Shopify.designMode) return;
  try {
    
// Scroll reveal
var revealEls = document.querySelectorAll('.tesa-reveal');
var revealObs = new IntersectionObserver(function(entries) {
  entries.forEach(function(e) {
    if (e.isIntersecting) {
      e.target.classList.add('visible');
      revealObs.unobserve(e.target);
    }
  });
}, { threshold: 0.06, rootMargin: '0px 0px -40px 0px' });
revealEls.forEach(function(el) { revealObs.observe(el); });

// Tabs
document.querySelectorAll('.tesa-tab-btn').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var t = btn.dataset.tab;
    document.querySelectorAll('.tesa-tab-btn').forEach(function(b) { b.classList.remove('active'); b.setAttribute('aria-selected','false'); });
    document.querySelectorAll('.tesa-tab-panel').forEach(function(p) { p.classList.remove('active'); });
    btn.classList.add('active');
    btn.setAttribute('aria-selected','true');
    document.getElementById('tesa-tab-' + t).classList.add('active');
  });
});

// Gallery thumbnails
document.querySelectorAll('.tesa-hero__thumb').forEach(function(thumb) {
  thumb.addEventListener('click', function() {
    var mainImg = document.getElementById('tesa-hero-main-img');
    if (mainImg) {
      mainImg.src = thumb.dataset.imgSrc;
      mainImg.alt = thumb.dataset.imgAlt;
    }
    document.querySelectorAll('.tesa-hero__thumb').forEach(function(t) { t.classList.remove('active'); });
    thumb.classList.add('active');
  });
});

// Variant selector
var variantSelect = document.getElementById('tesa-variant-selector');
if (variantSelect) {
  variantSelect.addEventListener('change', function() {
    var variantId = this.value;
    document.querySelectorAll('#tesa-variant-id').forEach(function(input) {
      input.value = variantId;
    });
    // Update all hidden variant inputs in forms
    document.querySelectorAll('.tesa-sticky-cta input[name="id"], .tesa-final-cta input[name="id"]').forEach(function(input) {
      input.value = variantId;
    });
  });
}

// Sticky CTA
var heroCta = document.getElementById('tesa-hero-cta');
var finalCta = document.getElementById('tesa-final-cta');
var stickyCta = document.getElementById('tesa-sticky-cta');
if (heroCta && finalCta && stickyCta) {
  var stickyObs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.target === heroCta) {
        if (!e.isIntersecting) stickyCta.classList.add('visible');
        else stickyCta.classList.remove('visible');
      }
      if (e.target === finalCta && e.isIntersecting) {
        stickyCta.classList.remove('visible');
      }
    });
  }, { threshold: 0 });
  stickyObs.observe(heroCta);
  stickyObs.observe(finalCta);
}

/* ── AJAX Add to Cart for Protocol Companions ── */
document.querySelectorAll('.tesa-pairing__atc').forEach(function(btn) {
  btn.addEventListener('click', function(e) {
    e.preventDefault();
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    btn.classList.add('is-adding');
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
    .then(function(res) { return res.json(); })
    .then(function() {
      btn.classList.remove('is-adding');
      btn.classList.add('is-added');
      btn.textContent = 'Added to Cart';

      /* Update cart count in Pipeline header */
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var countEls = document.querySelectorAll('.js-cart-count, .cart__count, [data-cart-count]');
          countEls.forEach(function(el) { el.textContent = cart.item_count; });
        });

      setTimeout(function() {
        btn.classList.remove('is-added');
        btn.textContent = 'Add to Cart';
      }, 2500);
    })
    .catch(function() {
      btn.classList.remove('is-adding');
      btn.textContent = 'Error — Try Again';
      setTimeout(function() { btn.textContent = 'Add to Cart'; }, 2000);
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
